import React from "react";

const POINTS = [
  {
    b: "Upcoming hearings",
    t: "next dates and listings for your matters, before the day.",
  },
  {
    b: "Related cases",
    t: "similar matters before other benches, ranked by relevance.",
  },
  {
    b: "Law changes",
    t: "notifications, circulars or rulings that affect your arguments.",
  },
];

const ALERTS = [
  {
    tag: "HEARING",
    title: "[Matter name] listed for final hearing",
    sub: "[High Court · Bench] · [Date] · Item [No.]",
    p: "High",
  },
  {
    tag: "RULING",
    title: "New judgment on ITC from non-existent suppliers",
    sub: "Matches issue 2 in [Matter name]",
    p: "High",
  },
  {
    tag: "NOTIFICATION",
    title: "CGST amendment on credit restrictions",
    sub: "May affect 3 of your active matters",
    p: "Medium",
  },
];

const AlertsSpotlight = () => (
  <section className="vd-section vd-section--soft">
    <div className="container">
      <div className="row g-5 align-items-center">
        <div className="col-lg-6">
          <span className="vd-eyebrow">LITIGATION ALERTS</span>
          <h2 className="vd-h2">
            Know what’s on the cause list before your client calls.
          </h2>
          <p className="vd-lead">
            Each litigation you create becomes a live watch. Vedum scores
            incoming listings, rulings and notifications against your matter’s
            issues and surfaces only what is relevant — with the reason why.
          </p>
          <div className="vd-numlist">
            {POINTS.map((p, i) => (
              <div key={p.b}>
                <span className="vd-num">{i + 1}</span>
                <span>
                  <strong>{p.b}</strong> — {p.t}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="vd-alerts">
            <div className="vd-alerts__head">
              <span>Alerts for your litigations</span>
              <span>This week</span>
            </div>
            {ALERTS.map((a) => (
              <div className="vd-alert" key={a.title}>
                <span className="vd-alert__tag">{a.tag}</span>
                <div>
                  <div className="vd-alert__title">{a.title}</div>
                  <div className="vd-alert__sub">{a.sub}</div>
                </div>
                <span
                  className={`vd-prio ${a.p === "High" ? "vd-prio--high" : "vd-prio--med"}`}
                >
                  {a.p}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AlertsSpotlight;
